export enum CustomizationThemesEnum {
  classic = "Classic",
  flat = "Flat",
  material = "Material",
  minimalistic = "Minimalistic",
  brutalism = "Brutalism",
  soft = "Soft"
}
